import React, { useEffect, useState } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { auth, db } from '../firebase';
import Spinner from './Spinner';
import BlockedUserScreen from './BlockedUserScreen';

function snapshotExists(snap) {
  return typeof snap.exists === 'function' ? snap.exists() : snap.exists;
}

const BlockedUserGate = ({ children }) => {
  const [user] = useAuthState(auth);
  const [blocked, setBlocked] = useState(null);

  useEffect(() => {
    if (!user) {
      setBlocked(null);
      return undefined;
    }
    setBlocked(null);
    const ref = doc(db, 'blockedUsers', user.uid);
    const unsub = onSnapshot(ref, (snap) => setBlocked(snapshotExists(snap)), () =>
      setBlocked(false),
    );
    return () => unsub();
  }, [user]);

  if (!user) {
    return children;
  }

  if (blocked === null) {
    return (
      <div className="container mt-5 py-5 text-center">
        <Spinner />
      </div>
    );
  }

  if (blocked) {
    return <BlockedUserScreen user={user} />;
  }

  return children;
};

export default BlockedUserGate;
